export function getAmountInfused(mgToInf: number, milliseconds: number): number {
    // give it a +- 1 percent error
    const variabilityFactor: number = 1 + 0.01 * (Math.random() - 0.5);
    const mgInfMillis: number = mgToInf * (milliseconds / 1000);
    return  variabilityFactor * mgInfMillis;
}